/**
 * Debug Configuration for Frontend
 * 
 * Central place to control debugging and logging across the application.
 * Set ENABLE_CACHE_LOGGING to false to disable cache-related console logs.
 */

export const DEBUG_CONFIG = {
  // Cache logging (set to false to reduce noise)
  ENABLE_CACHE_LOGGING: false,
  
  // Other debug flags
  ENABLE_API_LOGGING: false,
  ENABLE_PERFORMANCE_LOGGING: false,
  ENABLE_ERROR_LOGGING: true, // Keep error logging always on
};

/**
 * Conditional console.log wrapper for cache operations
 * Only logs if ENABLE_CACHE_LOGGING is true
 */
export const cacheLog = (...args) => {
  if (DEBUG_CONFIG.ENABLE_CACHE_LOGGING) {
    console.log(...args);
  }
};

/**
 * Conditional console.log wrapper for API operations
 * Only logs if ENABLE_API_LOGGING is true
 */
export const apiLog = (...args) => {
  if (DEBUG_CONFIG.ENABLE_API_LOGGING) {
    console.log(...args);
  }
};

/**
 * Conditional console.log wrapper for performance operations
 * Only logs if ENABLE_PERFORMANCE_LOGGING is true
 */
export const perfLog = (...args) => {
  if (DEBUG_CONFIG.ENABLE_PERFORMANCE_LOGGING) {
    console.log(...args);
  }
};